import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonos } from '../data/content';
export function Bonuses() {
  return <section className="w-full border-y border-surface-line bg-surface-alt" aria-labelledby="bonos-titulo" data-id="element-15" data-mp="plsk64cgd098">
      <div className="mx-auto max-w-6xl px-5 py-10 sm:px-6 sm:py-16" data-id="element-16" data-mp="ftwmguea3c5j">
        <div className="mx-auto max-w-2xl text-center" data-id="element-17" data-mp="fs3ffdzr6px0">
          <p className="inline-flex items-center gap-1.5 rounded-full border border-success-border bg-success-soft px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-success" data-id="element-18" data-mp="1tbzrn58sw6r">
            <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-19" data-mp="3o2eqg4vcix7e" />
            Sin costo extra
          </p>
          <h2 id="bonos-titulo" className="font-display mt-3 text-[1.6rem] leading-[1.05] text-ink-strong sm:text-4xl" data-id="element-20" data-mp="3t1rayiyqvs6t">
            Además, te llevas 5 recursos rápidos para aplicar desde el primer
            día
          </h2>
        </div>

        <ul className="mt-7 grid grid-cols-2 gap-2 sm:gap-3 lg:grid-cols-5" data-id="element-21" data-mp="3idwp7m125gma">
          {bonos.map(bono => <li key={bono.codigo} className="flex flex-col rounded-xl border border-surface-line bg-white p-3.5" data-id="element-22" data-mp="3dg4wwqwi3shk">
              <div className="flex items-center justify-between gap-2" data-id="element-23" data-mp="3r8kuvdajp0bm">
                <span className="text-[10px] font-extrabold uppercase tracking-wide text-brand" data-id="element-24" data-mp="3n5ohq23rxwf2">
                  {bono.codigo}
                </span>
                <span className="rounded bg-success-soft px-1.5 py-0.5 text-[10px] font-extrabold uppercase text-success" data-id="element-25" data-mp="2ugr2y8yruhr2">
                  Gratis
                </span>
              </div>
              <h3 className="font-display mt-2 text-base leading-tight text-ink-strong" data-id="element-26" data-mp="33hff0y4lu81b">
                {bono.titulo}
              </h3>
              <p className="mt-1.5 text-[12px] leading-snug text-ink" data-id="element-27" data-mp="nozvuihvvu4w">
                {bono.descripcion}
              </p>
              <p className="mt-auto pt-2.5 text-[11px] font-semibold text-ink-muted line-through" data-id="element-28" data-mp="iqor2m6g49tj">
                Valor {bono.valor}
              </p>
            </li>)}
        </ul>

        <p className="mt-5 text-center text-sm font-bold text-ink-strong" data-id="element-29" data-mp="3hgg7rw96q8e9">
          Valor total de los bonos:{' '}
          <span className="line-through decoration-brand decoration-2" data-id="element-30" data-mp="3lhi3w47t24c0">USD $95</span>{' '}
          <span className="text-success" data-id="element-31" data-mp="3qhwe9swvpqd7">incluidos gratis</span>
        </p>

        <div className="mx-auto mt-6 max-w-sm" data-id="element-32" data-mp="2ttq3eo9d61qh">
          <CTAButton label="Quiero los 6 tomos + 5 bonos" size="lg" fullWidth data-id="element-33" data-mp="2xu0bc6gpv27z" />
          <p className="mt-2.5 text-center text-[11px] font-semibold text-ink-muted" data-id="element-34" data-mp="2xrxn9rz4jj5w">
            Todo incluido · Pago único · Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}